import React from "react";
import {List, SquaresFour, MapTrifold } from "@phosphor-icons/react";


export default function ListStyle(props) {
	
	
	const styles = [
		{
			icon:<List size={16} />,
			value:'list',
			label:'List'
		},
		{
			icon:<SquaresFour size={16} />,
			value:'card',
			label:'Cards'
		},
		{
			icon:<MapTrifold size={16} />,
			value:'map',
			label:'Map'
		}
	]
	
	const handleClick = function(e){
		
		const v = e.target.closest(".style-option").dataset.value;
		
		if(props.onClick)
			props.onClick(v);
		
	}
		
		
	return (
		<ul className="list-style">
			{
				styles.map((a, idx)=>{ return (<li key={idx} onClick={handleClick} data-value={a.value} className={"style-option "+(a.value == props.value ? 'active':'')}>{a.icon} {a.label}</li>)})
			}
		</ul>
	)
}